export default __webpack_public_path__ + "static/Truth_gpt-daeb15abc302c450f096fde5d34cc949.webp";